// src/views/Exits/ExitsMobile.js
import { useMemo, useState, useEffect, useCallback, useRef } from "react";
import moment from "moment";
import { getExits } from "../../services/newdaily";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import { registerLocale } from "react-datepicker";
import TaskHeaderExit from "../../components/TaskHeaderExit/TaskHeaderExit";
import TaskExitCards from "../../components/TaskExitCards/TaskExitCards";
import styles from "./ExitsMobile.module.css";

import BackArrowIcon from "../../assets/svgs/back_arrow.svg";
import foldersImg from "../../assets/svgs/folders2.svg";

registerLocale("es", es);

const ExitsMobile = ({ refreshSignal, isMobile }) => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [rawSalidas, setRawSalidas] = useState({});
    const [loading, setLoading] = useState(false);
    const spinnerTimeoutRef = useRef(null);

    const formattedDate = useMemo(
        () => moment(selectedDate).format("YYYY-MM-DD"),
        [selectedDate]
    );

    const fetchSalidas = useCallback(async () => {
        try {
            // Reinicia el timer si ya existía
            if (spinnerTimeoutRef.current) clearTimeout(spinnerTimeoutRef.current);

            // Solo mostramos loading si tarda más de 1s
            spinnerTimeoutRef.current = setTimeout(() => {
                setLoading(true);
            }, 1000);

            const data = await getExits();
            setRawSalidas(data || {});
        } catch (e) {
            console.error("Error cargando salidas:", e);
            setRawSalidas({});
        } finally {
            if (spinnerTimeoutRef.current) {
                clearTimeout(spinnerTimeoutRef.current);
                spinnerTimeoutRef.current = null;
            }
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchSalidas();
    }, [fetchSalidas, refreshSignal]);

    useEffect(() => {
        return () => {
            if (spinnerTimeoutRef.current) {
                clearTimeout(spinnerTimeoutRef.current);
                spinnerTimeoutRef.current = null;
            }
        };
    }, []);

    const dayData = rawSalidas?.[formattedDate] || {};

    return (
        <>
            <div className={styles.datePickerContainerOuter}>
                <div className={styles.datePickerContainer}>
                    <div className={styles.datePickerWrapper}>
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => setSelectedDate(date)}
                            locale="es"
                            inline
                            calendarClassName={styles.customCalendar}
                        />
                    </div>
                </div>
            </div>

            <div className={styles.contentContainer}>

                <div className={styles.backRow}>
                    <a href="/admin" className={styles.backButton}>
                        <img
                            src={BackArrowIcon}
                            alt=""
                            aria-hidden="true"
                            className={styles.backIcon}
                        />
                        <span>Ver todos los empleados</span>
                    </a>
                </div>

                <div className={styles.headerWrapper}>
                    <TaskHeaderExit
                        key={formattedDate}
                        selectedDate={formattedDate}
                        isMobile={isMobile}
                    />
                </div>

                <div className={styles.cardsWrapper}>
                    {loading ? (
                        <div className={styles.loadingInCards}>
                            <div className={styles.spinner} />
                            <p className={styles.loadingText}>Cargando</p>
                        </div>
                    ) : Object.keys(dayData || {}).length === 0 ? (
                        <div className={styles.noExitContainer}>
                            <img src={foldersImg} alt="No exits" className={styles.noExitImage} />
                            <p className={styles.noExitText}>No hay salidas para este día</p>
                        </div>
                    ) : (
                        <TaskExitCards dayData={dayData} isMobile={isMobile} />
                    )}
                </div>
            </div>
        </>
    );
};

export default ExitsMobile;
